import { Component } from '@angular/core';
import { TagAdministrationComponent } from '../../organisms/tag-administration/tag-administration.component';
import { DividerModule } from 'primeng/divider';
import { HeaderComponent } from '../../atoms/header/header.component';

@Component({
  selector: 'app-configuration-tags',
  standalone: true,
  imports: [TagAdministrationComponent, DividerModule, HeaderComponent],
  templateUrl: './configuration-tags.component.html',
  styleUrl: './configuration-tags.component.scss',
})
export class ConfigurationTagsComponent {}
